import { createAction, createSlice } from "@reduxjs/toolkit";

// Types
import { RequiredDocument } from "../../@types/requiredDocument";
import { findRequiredDocuments } from "./actions/findRequiredDocuments";
import {addDocInfo} from "./actions/addDocInfo";
import {addCameraInfo} from "./actions/addCameraInfo";
import {isFromCamera} from "./actions/isFromCamera";
import {sendFile} from "./actions/sendFile";
import {sendPhoto} from "./actions/sendFile";


interface RequiredDocumentsState {
  requiredDocument: RequiredDocument[];
  findStatus: string;
  requiredDocumentCount: number;
}

const initialState = {
  requiredDocument: [],
  findStatus: "initial",
  requiredDocumentCount: 0,
} as RequiredDocumentsState;


const requiredDocumentShowSlice = createSlice({
  name: "requiredDocumentShow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(findRequiredDocuments.pending, (state, { payload}) => {
        state.findStatus = "pending";
        state.requiredDocument = [];
        state.requiredDocumentCount = 0
      })
      .addCase(findRequiredDocuments.fulfilled, (state, { payload }) => {
        state.requiredDocument =  payload;
        state.requiredDocumentCount = payload.filter((doc: { category: string | any[]; }) => doc.category != null).length
        state.findStatus = "fulfilled";
      })
      .addCase(findRequiredDocuments.rejected, (state) => {
        state.findStatus = "rejected";
      })
      .addCase(addDocInfo.fulfilled, (state, { payload }) => {
        payload.map((element)=>{
          state.requiredDocument.map((document) => {
            if (document.id === parseInt(element.from)) {
                 [...document.docInfo] = [element];
                 return document.isFromCamera = false
            }
            return document
          })
          return element
        })
      })
      .addCase(addCameraInfo.fulfilled, (state, { payload }) => {
        payload.map((element)=>{
          state.requiredDocument.map((document) => {
            if (document.id === element.category) {
                 [...document.cameraInfo] = [element];
                 return document.isFromCamera = true
            }
            return document
          })
          return element
        })
      })
      .addCase(isFromCamera.fulfilled, (state, { payload }) => {
        state.requiredDocument.map((document) =>{
          if(document.id === payload){
            [...document.docInfo] = [];
            return document.isFromCamera = true
          }
          return document
        })
      })
      .addCase(sendFile.fulfilled, (state, { payload})=>{
        state.requiredDocument.map((document) =>{
          if(document.id == payload[0]){
            document.loadingFromCameraStatus = ''
            document.loadingFromInputStatus = "fulfilled"
            return document.isLoaded = true
          }
          return document
        })
      })
      .addCase(sendPhoto.fulfilled, (state, { payload})=>{
        state.requiredDocument.map((document) =>{
          if(document.id == payload[0]){
            document.loadingFromInputStatus  = ''
            document.loadingFromCameraStatus = "fulfilled"
            return document.isLoaded = true
          }
          return document
        })
      })
      .addCase(sendFile.rejected, (state, { payload})=>{
        state.requiredDocument.map((document) =>{
          if(payload === undefined){
            document.loadingFromInputStatus = "rejected"
            return document.isLoaded = true
          }
          return document
        })
      })
  },
});

export const requiredDocumentShow = requiredDocumentShowSlice.reducer;
